import { motion } from 'framer-motion';
import React from 'react';
import './Button.module.scss';

type Props = {
    onClick?: () => void;
    children: React.ReactNode;
    grey?: boolean;
    lightgrey?: boolean;
    lightgreyRed?: boolean;
    red?: boolean;
    white?: boolean;
    style?: any;
};

export default function Button({
    onClick,
    children,
    grey,
    lightgrey,
    lightgreyRed,
    red,
    white,
    style,
}: Props) {
    return (
        <motion.div
            style={style}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.9 }}
            onClick={onClick}
            styleName={`button ${lightgreyRed ? 'lightgreyRed' : ''} ${
                red ? 'red' : ''
            } ${grey ? 'grey' : ''} ${white ? 'white' : ''} ${
                lightgrey ? 'lightgrey ' : ''
            }`}
        >
            <button type="submit" style={{ pointerEvents: 'all' }}>
                {children}
            </button>
        </motion.div>
    );
}
